import React, { useState, useEffect } from "react";
import { NavBar, List, Toast} from "antd-mobile";
import {getNavBarContainerStyle} from "../../../../utils/deviceUtils";
import { CheckCircleFill } from "antd-mobile-icons";
import { useNavigate } from "react-router-dom";
import { t } from "../../../../i18n";
import { useTranslation } from "react-i18next";
import { reloadNativeWebLocal } from "../../../../utils/appRuntime";
import { setAllowNavigation } from "../../../../hooks/usePreventEdgeSwipe";

interface LanguagePageProps {}

const LanguagePage: React.FC<LanguagePageProps> = () => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const [currentLang, setCurrentLang] = useState('zh-CN');

    useEffect(() => {
        setCurrentLang(i18n.language);
    }, []);

    const handleLanguageChange = (lang: string) => {
        let uploadingToast = Toast.show({
            content: t('common.loading'),
            position: 'center',
            duration: 0,
            maskClickable: false
        });

        setCurrentLang(lang);
        i18n.changeLanguage(lang)
            .then(() => {
                // 通知原生端更新语言配置（原生端会重启 Activity）
                reloadNativeWebLocal();
                // 设置允许导航标记，避免beforeunload事件拦截页面重载
                setAllowNavigation(true);

                // 延迟重载，让原生端先处理
                setTimeout(() => {
                    window.location.reload();
                    uploadingToast.close()
                }, 100);
            })
            .catch((err: Error) => {
                console.error('Error changing language:', err);
            });
    };

    return (
        <div className="flex flex-col h-screen bg-white">
            <div {...getNavBarContainerStyle()}>
                <NavBar
                onBack={() => navigate(-1)}
            >
                {t('pages.useMenu.language')}
                </NavBar>
            </div>

            <List className="mt-2">
                <List.Item
                    extra={currentLang === 'zh-CN' ? <CheckCircleFill color="#00b578" /> : null}
                    onClick={() => handleLanguageChange('zh-CN')}
                    arrowIcon={false}
                >
                    简体中文
                </List.Item>
                <List.Item 
                    extra={currentLang === 'en-US' ? <CheckCircleFill color="#00b578" /> : null}
                    onClick={() => handleLanguageChange('en-US')}
                    arrowIcon={false}
                >
                    English
                </List.Item>
                <List.Item
                    extra={currentLang === 'es-ES' ? <CheckCircleFill color="#00b578" /> : null}
                    onClick={() => handleLanguageChange('es-ES')}
                    arrowIcon={false}
                >
                    Español
                </List.Item>
            </List>
        </div>
    );
};

export default LanguagePage;